import { ImageLoader } from 'next/legacy/image';

export const CalmSleepLogoColor = { White: 'White', Gradient: 'Gradient' } as const;
type CalmSleepLogoColorType = (typeof CalmSleepLogoColor)[keyof typeof CalmSleepLogoColor];

export interface CalmSleepLogoProps {
	className?: string;
	height?: number;
	color?: CalmSleepLogoColorType;
	loader?: ImageLoader;
	'aria-label'?: string;
}
